namespace aq.dashboard.widgets {
    export class PortfolioMapWidgetCtrl {
        private selectedIndicator: any;
        private selectedGroup: any;
        private states = [{ "id": 0, "text": "Alabama" }, { "id": 1, "text": "Alaska" }, { "id": 2, "text": "American Samoa" }, { "id": 3, "text": "Arizona" }, { "id": 4, "text": "Arkansas" }, { "id": 5, "text": "California" }, { "id": 6, "text": "Colorado" }, { "id": 7, "text": "Connecticut" }, { "id": 8, "text": "Delaware" }, { "id": 9, "text": "District Of Columbia" }, { "id": 10, "text": "Federated States Of Micronesia" }, { "id": 11, "text": "Florida" }, { "id": 12, "text": "Georgia" }, { "id": 13, "text": "Guam" }, { "id": 14, "text": "Hawaii" }, { "id": 15, "text": "Idaho" }, { "id": 16, "text": "Illinois" }, { "id": 17, "text": "Indiana" }, { "id": 18, "text": "Iowa" }, { "id": 19, "text": "Kansas" }, { "id": 20, "text": "Kentucky" }, { "id": 21, "text": "Louisiana" }, { "id": 22, "text": "Maine" }, { "id": 23, "text": "Marshall Islands" }, { "id": 24, "text": "Maryland" }, { "id": 25, "text": "Massachusetts" }, { "id": 26, "text": "Michigan" }, { "id": 27, "text": "Minnesota" }, { "id": 28, "text": "Mississippi" }, { "id": 29, "text": "Missouri" }, { "id": 30, "text": "Montana" }, { "id": 31, "text": "Nebraska" }, { "id": 32, "text": "Nevada" }, { "id": 33, "text": "New Hampshire" }, { "id": 34, "text": "New Jersey" }, { "id": 35, "text": "New Mexico" }, { "id": 36, "text": "New York" }, { "id": 37, "text": "North Carolina" }, { "id": 38, "text": "North Dakota" }, { "id": 39, "text": "Northern Mariana Islands" }, { "id": 40, "text": "Ohio" }, { "id": 41, "text": "Oklahoma" }, { "id": 42, "text": "Oregon" }, { "id": 43, "text": "Palau" }, { "id": 44, "text": "Pennsylvania" }, { "id": 45, "text": "Puerto Rico" }, { "id": 46, "text": "Rhode Island" }, { "id": 47, "text": "South Carolina" }, { "id": 48, "text": "South Dakota" }, { "id": 49, "text": "Tennessee" }, { "id": 50, "text": "Texas" }, { "id": 51, "text": "Utah" }, { "id": 52, "text": "Vermont" }, { "id": 53, "text": "Virgin Islands" }, { "id": 54, "text": "Virginia" }, { "id": 55, "text": "Washington" }, { "id": 56, "text": "West Virginia" }, { "id": 57, "text": "Wisconsin" }, { "id": 58, "text": "Wyoming" }];
        private state_hash = {
            'AL': 'Alabama',
            'AK': 'Alaska',
            'AS': 'American Samoa',
            'AZ': 'Arizona',
            'AR': 'Arkansas',
            'CA': 'California',
            'CO': 'Colorado',
            'CT': 'Connecticut',
            'DE': 'Delaware',
            'DC': 'District Of Columbia',
            'FM': 'Federated States Of Micronesia',
            'FL': 'Florida',
            'GA': 'Georgia',
            'GU': 'Guam',
            'HI': 'Hawaii',
            'ID': 'Idaho',
            'IL': 'Illinois',
            'IN': 'Indiana',
            'IA': 'Iowa',
            'KS': 'Kansas',
            'KY': 'Kentucky',
            'LA': 'Louisiana',
            'ME': 'Maine',
            'MH': 'Marshall Islands',
            'MD': 'Maryland',
            'MA': 'Massachusetts',
            'MI': 'Michigan',
            'MN': 'Minnesota',
            'MS': 'Mississippi',
            'MO': 'Missouri',
            'MT': 'Montana',
            'NE': 'Nebraska',
            'NV': 'Nevada',
            'NH': 'New Hampshire',
            'NJ': 'New Jersey',
            'NM': 'New Mexico',
            'NY': 'New York',
            'NC': 'North Carolina',
            'ND': 'North Dakota',
            'MP': 'Northern Mariana Islands',
            'OH': 'Ohio',
            'OK': 'Oklahoma',
            'OR': 'Oregon',
            'PW': 'Palau',
            'PA': 'Pennsylvania',
            'PR': 'Puerto Rico',
            'RI': 'Rhode Island',
            'SC': 'South Carolina',
            'SD': 'South Dakota',
            'TN': 'Tennessee',
            'TX': 'Texas',
            'UT': 'Utah',
            'VT': 'Vermont',
            'VI': 'Virgin Islands',
            'VA': 'Virginia',
            'WA': 'Washington',
            'WV': 'West Virginia',
            'WI': 'Wisconsin',
            'WY': 'Wyoming'
        };
        private groupViewItems: any[];
        private selectedGroupViewItems: any[];
        private selectedGroupTypeId: string;
        private data: any;
        /* @ngInject */
        constructor(
            private $scope,
            private buildings: aq.common.models.Building[],
            private buildingGroups: any[],
            private users: aq.common.models.User[],
            private Messages: aq.services.Messages,
            private RestangularV3: restangular.IService,
            private Restangular: restangular.IService,
            private config,
            private MockDataService: MockDataService,
            private DrillDataService: DrillDataService
        ) {
            this.MockDataService.extendBuildings(this.buildings);
            _.each(this.buildings, (b) => {
                if (!b.longitude || !b.latitude) {
                    const coordinates = _.find(this.MockDataService.addresses, (a) => a.address == b.address);
                    if (coordinates) {
                        b.longitude = coordinates.lon;
                        b.latitude = coordinates.lat;
                    }
                }
            });

            this.buildViewItems();
            this.selectedGroupTypeId = '1';
            this.selectedIndicator = '1';

            this.data = { layers: [] };
            this.onSelectedGroupTypeChange();
        }
        public onIndicatorChange() {
            this.selectedGroup = null;
            this.getValues();
        }
        public onSelect(id) {
            const type = 'building';
            this.$scope.$emit('dataSelectedEmit', {
                id: Math.random(),
                type,
                data: {
                    id,
                    idProperty: 'buildingId'
                }
            });
        }
        public getValues() {
            if (this.selectedIndicator == 1) {
                const data = this.MockDataService.getBuildingUtilityData();
                const processedData = this.DrillDataService.processData(data, 'groupId', 'groupName', this.selectedGroupTypeId as any);
                _.each(this.selectedGroupViewItems, (viewItem) => {
                    const dataItem = _.find(processedData, (item) => viewItem.id == item.id);
                    if (!dataItem) {
                        return;
                    }
                    viewItem.value = dataItem.allBudget.percent;
                    viewItem.displayValue = dataItem.allBudget.percent + '%';
                });
            }
            if (this.selectedIndicator == 2) {
                const data = this.MockDataService.getUserEngagementData();
                const processedData = this.DrillDataService.processUserEngagementData(data, 'groupId', 'groupName', this.selectedGroupTypeId as any);
                _.each(this.selectedGroupViewItems, (viewItem) => {
                    const dataItem = _.find(processedData, (item) => viewItem.id == item.id);
                    if (!dataItem) {
                        return;
                    }
                    viewItem.value = dataItem.score;
                    viewItem.displayValue = dataItem.score.toString();
                });
            }
        }
        public onSelectedGroupTypeChange() {
            const groupDefinition: BuildingGroupDefinition = _.find(this.MockDataService.groups, (group) => group.id == this.selectedGroupTypeId);
            this.selectedGroupViewItems = groupDefinition.groups;
            _.each(this.selectedGroupViewItems, (item, index) => {
                if (groupDefinition.colors && groupDefinition.colors.length) {
                    item.color = groupDefinition.colors[index % groupDefinition.colors.length];
                }
            });
            this.buildMapData();
            this.getValues();
        }
        public buildViewItems() {
            this.groupViewItems = [];
            _.each(this.MockDataService.groups, (group: BuildingGroupDefinition) => {
                this.groupViewItems.push({
                    id: group.id,
                    name: group.name,
                    value: 0,
                    displayValue: '',
                    color: ''
                });
            });
        }
        public selectGroup(group) {
            //TODO add group type
            if (this.selectedGroupTypeId != '1') {
                return;
            }

            const type = 'buildingGroup';
            this.$scope.$emit('dataSelectedEmit', {
                id: Math.random(),
                type,
                data: {
                    id: group.id,
                    idProperty: 'groupId'
                }
            });
        }
        //public generateData() {
        //    this.data = [];
        //    _.each(this.buildingGroups, (group) => {
        //        const stateName = this.state_hash[group.name];
        //        let state = null;
        //        if (!stateName) {
        //            state = _.find(this.states, (s) => s.text.toLowerCase() == group.name.toLowerCase());
        //        } else {
        //            state = _.find(this.states, (s) => s.text.toLowerCase() == stateName.toLowerCase());
        //        }
        //        if (!state) {
        //            return;
        //        }
        //        const rnd = Math.random();
        //        let color = '';
        //        if (rnd > 0.66) {
        //            color = 'g';
        //        } else if (rnd > 0.33) {
        //            color = 'y';
        //        } else {
        //            color = 'r';
        //        }
        //        this.data.push({
        //            id: (state.id < 10 ? '0' : '') + state.id,
        //            color,
        //            name: group.name,
        //            groupId: group.id,
        //            value: Math.round(rnd * 100) / 100
        //        });
        //    });
        //}

        public buildMapData() {
            const layers = [];
            const assignedBuildings = [];
            _.each(this.selectedGroupViewItems, (group) => {
                const layer = {
                    id: group.id,
                    name: group.name,
                    color: group.color,
                    points: []
                };
                _.each(group.buildings, (buildingId) => {
                    const buildingData = _.find(this.buildings, (b) => b.id == buildingId);
                    if (!buildingData) {
                        return;
                    }
                    assignedBuildings.push(buildingId);
                    layer.points.push({
                        id: buildingId,
                        name: buildingData.name,
                        lon: buildingData.longitude,
                        lat: buildingData.latitude
                    });
                });
                layers.push(layer);
            });
            //const layerOther = {
            //    id: 12345678,
            //    name: 'Other',
            //    color: '#DADADA',
            //    points: []
            //};
            //_.each(this.buildings, (b) => {
            //    if (!_.find(assignedBuildings, (assignedId) => assignedId == b.id)) {
            //        layerOther.points.push({
            //            id: b.id,
            //            name: b.name,
            //            lon: b.longitude,
            //            lat: b.latitude
            //        });
            //    }
            //});
            //layers.splice(0, 0, layerOther);
            this.data.layers = layers;
        }
        public emitSelectedEvent(item) {
            const type = 'buildingGroup';
            this.$scope.$emit('dataSelectedEmit', {
                id: Math.random(),
                type,
                data: {
                    id: item.groupId,
                    idProperty: 'groupId'
                }
            });
        }
    }
    angular.module('aq.dashboard.widgets').controller('PortfolioMapWidgetCtrl', PortfolioMapWidgetCtrl);
}
